<kiene-kiene-table [tableDescriptor]="tableDescriptor">
    <div toolbarElementCenter>
        <span>Nicht abgeschlossene Befunde: {{ nichtAbgeschlossenCount }}</span>
        <div style="margin-left: 12px">
            <div *ngIf="dateRange?.zeit_von">
                <mat-chip-list>
                    <mat-chip (removed)="resetDateRangeFilter()">
                        <span
                            >Filter: {{ dateRange?.zeit_von | date: "dd.MM.yyyy" }} -
                            {{ dateRange?.zeit_bis | date: "dd.MM.yyyy" }}</span
                        >
                        <button matChipRemove>
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip>
                    <mat-chip *ngFor="let m of selectedMaterialien" (removed)="removeSelectedMaterial(m)">
                        <span>Filter: {{ m?.bezeichnung }}</span>
                        <button matChipRemove>
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip>
                </mat-chip-list>
            </div>
        </div>
    </div>
</kiene-kiene-table>
